import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"
import { InputType } from "../../../components/TextInput/const/InputType.enum"

export default () => {
	const { t } = useTranslation("microsites", { keyPrefix: "form.dataTableHeaders.landingReviews" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		key: "id",
		title: "ID",
		dataIndex: "id",
		sorteable: true,
		autoSort: false,
		width: "5%"
	},
	{
		title: t("name"),
		dataIndex: "name",
		key: "name",
		width: "20%"
	},
	{
		title: t("content"),
		dataIndex: "content",
		key: "content",
		width: "60%"
	},
	{
		title: t("weight"),
		dataIndex: "weight",
		key: "weight",
		inputType: InputType.NUMBER,
		sorteable: true,
		editable: true,
		width: "5%"
	},
	{
		title: "",
		key: "actions",
		dataIndex: "actions",
		width: "10%"
	}
]
